import InternalStaticAnchorPortal from 'models/application/anchor/types/internalStatic/types/Portal';

export default class InternalStaticAnchorPortalService {
	toModel() {
		return new InternalStaticAnchorPortal();
	}
}
